import DropDown from "../DropDown";
import React, {ReactElement} from "react";

import styles from './index.module.scss'

interface PickerListProps {
    id: string | number,
    title: string,
    icon?: ReactElement
}

interface DropDownPickerProps {
    btn: ReactElement | ((isOpen: boolean) => ReactElement),
    pickerList: PickerListProps[],
    closeDropDownByPick?: boolean,
    getValue: (value: string | number) => void,
    position?: 'left' | 'right' | 'side-right',
    maxVisibleItems?: number,
    dropdownClassName?: string,
    contentClassName?: string,
    listClassName?: string,
    itemClassName?: string,
    usePortal?: boolean,
}

export default function DropDownPicker({
    pickerList,
    getValue,
    btn,
    closeDropDownByPick,
    position = 'left',
    maxVisibleItems,
    dropdownClassName = '',
    contentClassName = '',
    listClassName = '',
    itemClassName = '',
    usePortal = true,
}: DropDownPickerProps) {
    const shouldScroll = typeof maxVisibleItems === 'number' && pickerList.length > maxVisibleItems
    const scrollStyle: React.CSSProperties | undefined = shouldScroll
        ? { maxHeight: `calc(${maxVisibleItems} * 48px)`, overflowY: 'auto' }
        : undefined

    return (
        <DropDown
            btn={btn}
            closeDropDownByPick={closeDropDownByPick}
            position={position}
            usePortal={usePortal}
            dropdownClassName={dropdownClassName}
            contentClassName={contentClassName}
        >
            <div className={`${styles.dropdownPicker} ${listClassName}`} style={scrollStyle}>
                {pickerList.map((item: PickerListProps) => (
                    <div key={item.id} className={`${styles.dropdownPicker__item} ${itemClassName}`} onClick={() => getValue(item.id)}>
                        {item.icon}
                        <p>{item.title}</p>
                    </div>
                ))}
            </div>
        </DropDown>
    )
}
